import { RestrictedRoute } from "RestrictedRoute";
import { AppLayout } from "components/AppLayout/AppLayout";
import Loader from "components/DesignSystem/Loader/loader";
import { RoutesAccrossApps } from "components/RoutesAcrossApps/RoutesAcrossApps";
import { LeftBar, LeftBarItem, LeftBarLogo } from "components/Sidebar/LeftBar";
import { SidebarStickyGroup } from "components/Sidebar/SidebarStickyGroup";
import { TaskList } from "components/Task/TaskList";
import { TopBar } from "components/TopBar/TopBar";
import { Home as TaxHomePage } from "components/home/Home";
import { Filings as FilingsIcon } from "components/icons/LeftNav/Filings";
import { Home } from "components/icons/LeftNav/Home";
import { InkleTaxLogo } from "components/icons/Logos/InkleTaxLogo";
import { InkleTaxSymbol } from "components/icons/Logos/InkleTaxSymbol";
import { useCurrentAppContext } from "contexts/CurrentAppContext";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useDashboardBanner } from "hooks/useDashboardBanner";
import { useEffect } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import { DashboardBanner } from "signInSignUp/DashboardBanner";
import "static/styles/containers/dashboard.css";

const Navbar = () => (
  <div className="t-h-full t-flex t-flex-col t-justify-between">
    <div>
      <LeftBarItem exact to="/" icon={Home}>
        Home
      </LeftBarItem>
      <LeftBarItem to="/filings" icon={FilingsIcon}>
        Filings
      </LeftBarItem>
    </div>
  </div>
);

export const PersonalTaxDashboard = () => {
  const { path, url } = useRouteMatch();
  const { shouldRenderBanner } = useDashboardBanner();
  const { uuid } = useCurrentGroupContext();
  const { dispatch: currentAppDispatch } = useCurrentAppContext();

  const isGroupLoaded = Boolean(uuid);

  const renderHome = () => (isGroupLoaded ? <TaxHomePage /> : <Loader />);

  useEffect(() => {
    currentAppDispatch({
      type: "SET_CURRENT_APP",
      payload: { currentApp: "Tax" },
    });
  }, [currentAppDispatch]);

  return (
    <AppLayout
      sidebar={
        <LeftBar
          logo={
            <LeftBarLogo
              url={url}
              logo={InkleTaxLogo}
              symbol={InkleTaxSymbol}
            />
          }
          showCollapse
          stickyNav={<SidebarStickyGroup />}
        >
          <Navbar />
        </LeftBar>
      }
      topbar={
        <TopBar
          logo={<LeftBarLogo logo={InkleTaxLogo} symbol={InkleTaxSymbol} />}
          nav={<Navbar />}
          stickyNav={<SidebarStickyGroup />}
        />
      }
      banner={<DashboardBanner />}
      noVerticalGap={!shouldRenderBanner}
    >
      <Switch>
        <RestrictedRoute path={`${path}/filings`} component={TaskList} />
        <RestrictedRoute exact path={path} render={renderHome} />
        <RoutesAccrossApps />
      </Switch>
    </AppLayout>
  );
};
